import { Loader2 } from "lucide-react";

/**
 * SendButtonLogo - زر الإرسال مع الشعار المتحرك
 * @param {number} size - حجم الزر (default: 36)
 * @param {boolean} loading - حالة التحميل
 */
export function SendButtonLogo({ size = 36, loading = false }) {
  return (
    <div 
      className="relative rounded-full bg-primary overflow-hidden flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin text-primary-foreground" />
      ) : (
        <>
          {/* Animated Ring */}
          <svg 
            className="absolute inset-0" 
            width={size} 
            height={size} 
            viewBox="0 0 100 100"
          >
            <circle 
              cx="50" cy="50" r="44" 
              fill="none" 
              className="stroke-primary-foreground"
              strokeWidth="2" 
              strokeDasharray="8 12"
              opacity="0.4"
            >
              <animateTransform 
                attributeName="transform" 
                type="rotate" 
                from="0 50 50" 
                to="360 50 50" 
                dur="15s" 
                repeatCount="indefinite" 
              />
            </circle>
          </svg>
          
          {/* H Letter */}
          <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 100 100" className="relative z-10">
            <g className="fill-primary-foreground">
              <rect x="20" y="20" width="16" height="60" rx="4" />
              <rect x="64" y="20" width="16" height="60" rx="4" />
              <rect x="20" y="41" width="60" height="18" rx="4" />
            </g>
          </svg>
        </>
      )}
    </div>
  );
}

export default SendButtonLogo;
